export const BUTTON = {
  type: 'Button',
};

export const TEXTBOX = {
  type: 'Input',
};

export const INPUT = {
  type: 'Input',
};

export const FORM = {
  type: 'Form',
};

export const CARD = {
  type: 'Card',
};

export const FILTER = {
  type: 'Option',
};

export const CONTENT = {
  type: 'Content',
};

export const DROPDOWN = {
  type: 'DropDown',
};

export const OPTION = {
  type: 'Option',
};

export const MODAL = {
  type: 'Modal',
};

export const INTERSTITIAL = {
  type: 'Interstitial',
};

export const BANNER = {
  type: 'Banner',
};

export const LIST = {
  type: 'List',
};

export const PIN = {
  type: 'Pin',
};

export const ANALYTICS_EVENT = {
  type: 'AnalyticsEvent',
};

export const DESTINATION_SEARCH = {
  type: 'DestinationSearch',
};

export const MAP_PAN_ZOOM = {
  type: 'MapPanZoom',
};

export const PAGE = {
  type: 'Page',
};

export const NOTICE = {
  type: 'Notice',
};

export const IMAGE = {
  type: 'Image',
};

export const TAB = {
  type: 'Tab',
};
